export default "__VITE_ASSET__TViUc$Fw__"